import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, verifyPassword, bindAccount } from './modules'
import { removeSalt, getSalt, languageChange } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const AutoRedirect = Loadable({
    loader: () => import('./AutoRedirect'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          oauthAutoRedirectState: state.oauthAutoRedirectState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          getSalt,
          verifyPassword,
          bindAccount,
          removeSalt,
          languageChange,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/auto-redirect`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <AutoRedirect {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
